const textField = {
  defaultProps: {
    variant: "outlined",
    size: "small",
    fullWidth: false, // lo sigues controlando en cada uso
  },
};

export default textField;
